import PropTypes from 'prop-types';
import React from 'react';

import ButtonHoverAnimation from 'components/ButtonHoverAnimation';

function CallToAction(props) {
  const { url, text } = props;

  return (
    <div className="ontheshow__call-to-action">
      <div className="ontheshow__call-to-action-gradient" />

      <div className="ontheshow__call-to-action-content">
        <ButtonHoverAnimation
          url={url}
          title={text}
          type="link"
        />
      </div>
    </div>
  );
}

CallToAction.propTypes = {
  text: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

CallToAction.defaultProps = {

};

export default CallToAction;
